import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

interface SportType {
  id: number;
  name: string;
}

const fetchSportTypes = async (): Promise<SportType[]> => {
  try {
    const { data } = await api.get<SportType[]>('/api/sport-types');
    return data;
  } catch (error) {
    console.error('Error en fetchSportTypes:', error);
    if (error instanceof Error) {
      throw new Error(`Error al cargar los tipos de deportes: ${error.message}`);
    }
    throw new Error('Error desconocido al cargar los tipos de deportes');
  }
};

export const useSportTypes = () => {
  const { 
    data: sportTypes = [], 
    isLoading, 
    error,
    isError 
  } = useQuery({
    queryKey: ['sport-types'],
    queryFn: fetchSportTypes,
    retry: 1,
    refetchOnWindowFocus: false
  });

  return {
    sportTypes,
    isLoading,
    error: isError ? (error instanceof Error ? error.message : 'Error desconocido al cargar los tipos de deportes') : null
  };
}; 